import * as THREE from "three";
import { GLASS_PARAMS } from "./GlassDefeault";
import { applyRadiusColor } from "./RadiusColor";

export function createGlass(topColor, bottomColor) {
  const group = new THREE.Group();
  // スケール調整
  const scaleFactor = GLASS_PARAMS.scaleFactor;

  // グラス(ダイソービールグラス400ml)
  const glassGeometry = new THREE.CylinderGeometry(
    GLASS_PARAMS.glass.topRadius * scaleFactor,
    GLASS_PARAMS.glass.bottomRadius * scaleFactor,
    GLASS_PARAMS.glass.height * scaleFactor,
    GLASS_PARAMS.glass.radialSegments,
    GLASS_PARAMS.glass.heightSegments,
    GLASS_PARAMS.glass.openEnded
  );

  // せん断変形の行列を作成
  const shearMatrix = new THREE.Matrix4();
  shearMatrix.set(
    ...GLASS_PARAMS.shearMatrix
  );

  // ジオメトリにせん断変形を適用
  glassGeometry.applyMatrix4(shearMatrix);

  // せん断変形で法線がずれる可能性があるため再計算する
  glassGeometry.computeVertexNormals();

  // 頂点色適用: sideColorは明示的に渡さない（ケースに応じてRadiusColor側で判断）
  applyRadiusColor(glassGeometry, topColor, bottomColor, GLASS_PARAMS.glass.color);

  const glassMaterial = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    shininess: GLASS_PARAMS.glass.shininess,
    vertexColors: true,
    transparent: true,
    opacity: 1,
  });
  const glassMesh = new THREE.Mesh(glassGeometry, glassMaterial);
  glassMesh.position.y = (GLASS_PARAMS.glass.yOffset + GLASS_PARAMS.glass.height / 2) * scaleFactor;
  group.add(glassMesh);

  // 環境光とスポットライトを追加してリアルに照らす
  const ambientLight = new THREE.AmbientLight(
    GLASS_PARAMS.light.ambient.color,
    GLASS_PARAMS.light.ambient.intensity
  );
  const spotLight = new THREE.SpotLight(
    GLASS_PARAMS.light.spot.color,
    GLASS_PARAMS.light.spot.intensity
  );
  spotLight.position.set(
    ...GLASS_PARAMS.light.spot.position.map(v => v * scaleFactor)
  );
  spotLight.castShadow = true;
  group.add(ambientLight);
  group.add(spotLight);

  return group;
}
